module.exports = __webpack_public_path__ + "static/join-79592555423e0bc4abd5cdd9c03a300d.png";